<template>
  <div v-loading="loading" class="rj-page-card">
    <div class="rj-page-card__title">
      基础信息
    </div>
    <div class="rj-page-card__content">
      <el-form ref="form" :model="formDataExt" class="baseInfoForm">
        <div class="rj-row">
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                单据编号：
              </div>
              <div class="rj-baseinfo__item">
                {{ formData.orderNum }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                申请时间：
              </div>
              <div class="rj-baseinfo__item">
                {{ formData.applicantTime }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                申请人姓名：
              </div>
              <div class="rj-baseinfo__item">
                {{ formData.applicantName }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                申请人所属部门：
              </div>
              <div class="rj-baseinfo__item">
                {{ formData.applicantDepartment }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                客户名称：
              </div>
              <div class="rj-baseinfo__item">
                {{ formDataExt.customerName }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                客户编码：
              </div>
              <div class="rj-baseinfo__item">
                {{ formDataExt.customerCode }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                客户类型：
              </div>
              <div class="rj-baseinfo__item">
                {{ formDataExt.customerType }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                预计交易规模(万元)：
              </div>
              <div class="rj-baseinfo__item">
                {{ formDataExt.proDealSize }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                企业状态：
              </div>
              <div class="rj-baseinfo__item">
                {{ formDataExt.enterpriseStatus }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                注册资本(万元)：
              </div>
              <div class="rj-baseinfo__item">
                {{ formDataExt.registeredCapital }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                注册资本币种：
              </div>
              <div class="rj-baseinfo__item">
                {{ formDataExt.realRegisteredCapitalCurrency }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                注册资本币种：
              </div>
              <div class="rj-baseinfo__item">
                {{ formDataExt.realRegisteredCapitalCurrency }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                法人：
              </div>
              <div class="rj-baseinfo__item">
                {{ formDataExt.legalPerson }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                法人类型：
              </div>
              <div class="rj-baseinfo__item">
                {{ formDataExt.legalPersonType }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                企业类型：
              </div>
              <div class="rj-baseinfo__item">
                {{ formDataExt.enterpriseType }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                成立日期：
              </div>
              <div class="rj-baseinfo__item">
                {{ formDataExt.establishTime }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                是否微小企业：
              </div>
              <div class="rj-baseinfo__item">
                {{ formDataExt.tinyEnterpriseFlag }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                人员规模：
              </div>
              <div class="rj-baseinfo__item">
                {{ formDataExt.scale }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                企业评分：
              </div>
              <div class="rj-baseinfo__item">
                {{ formDataExt.score }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                参保人数：
              </div>
              <div class="rj-baseinfo__item">
                {{ formDataExt.personNum }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                统一社会信用代码：
              </div>
              <div class="rj-baseinfo__item">
                {{ formDataExt.creditCode }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                更新日期：
              </div>
              <div class="rj-baseinfo__item">
                {{ formDataExt.establishUpdateTime }}
              </div>
            </div>
          </div>
          <div class="rj-col-1">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                注册地址：
              </div>
              <div class="rj-baseinfo__item">
                {{ formDataExt.address }}
              </div>
            </div>
          </div>
          <div class="rj-col-1">
            <el-form-item prop="businessRange" label="经营范围：">
              <el-input v-model.trim="formDataExt.businessRange" disabled type="textarea" :rows="3" placeholder="请输入文本" maxlength="200" show-word-limit />
            </el-form-item>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                吊销日期：
              </div>
              <div class="rj-baseinfo__item">
                {{ formDataExt.revokeTime }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                吊销原因：
              </div>
              <div class="rj-baseinfo__item">
                {{ formDataExt.revokeReason }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                注销日期：
              </div>
              <div class="rj-baseinfo__item">
                {{ formDataExt.logoffTime }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                注销原因：
              </div>
              <div class="rj-baseinfo__item">
                {{ formDataExt.logoffReason }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                申请类型：
              </div>
              <div class="rj-baseinfo__item">
                <span v-if="formData.applicantType === 0">固定额度</span>
                <span v-if="formData.applicantType === 1">临时额度</span>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                申请类别：
              </div>
              <div class="rj-baseinfo__item">
                {{ formDataExt.applicantCategory }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                申请额度(万元)：
              </div>
              <div class="rj-baseinfo__item">
                {{ formDataExt.applicantLimit }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                申请账期：
              </div>
              <div class="rj-baseinfo__item">
                {{ formDataExt.applicantPeriod }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                是否涉及定制化：
              </div>
              <div class="rj-baseinfo__item">
                <span v-if="formDataExt.customFlag === 0">否</span>
                <span v-if="formDataExt.customFlag === 1">是</span>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                付款方式：
              </div>
              <div class="rj-baseinfo__item">
                {{ formDataExt.payType }}({{ formDataExt.otherPayType }})
              </div>
            </div>
          </div>
          <div class="rj-col-1">
            <el-form-item prop="additionalTerms">
              <template #label>
                增信措施：
              </template>
              <el-input v-model.trim="formDataExt.addMeasure" disabled type="textarea" :rows="3" placeholder="请输入文本" maxlength="200" show-word-limit />
            </el-form-item>
          </div>
          <div class="rj-col-1">
            <el-form-item prop="applicantReason">
              <template #label>
                申请理由：
              </template>
              <el-input
                v-model.trim="formDataExt.applicantReason"
                disabled
                type="textarea"
                :rows="3"
                placeholder="请输入文本"
                maxlength="200"
                show-word-limit
              />
            </el-form-item>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                审批结果是否通知：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="customerCode">
                  <el-radio-group v-model="formDataExt.informFlag" disabled>
                    <el-radio v-for="(item, index) in isSendEmail" :key="index" :label="item.value">
                      {{ item.label }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </div>
          </div>
          <div v-if="formDataExt.informFlag === 1" class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__item">
                {{ formDataExt.email }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                锐捷商务：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="businessName">
                  {{ formData.businessName }}
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script type="es6">

export default {
  data () {
    return {
      formData: {
        orderNum: '', // 单据编号
        applicantName: '', // 申请人姓名
        applicantTime: '', // 申请时间
        applicantDepartment: '', // 申请人所属部门
        applicant: '', // 申请人账号
        applicantDepartmentCode: '', // 申请人所属部门编码
        applicantType: '' // 申请类型
      },
      formDataExt: {
        customerName: '', // 客户名称
        customerType: '', // 客户类型
        enterpriseStatus: '', // 企业状态
        registeredCapitalCurrency: '', // 注册资本币种
        legalPerson: '', // 法人
        enterpriseType: '', // 企业类型
        tinyEnterpriseFlag: '', // 是否微小企业
        score: '', // 企业评分
        creditCode: '', // 统一社会信用代码
        customerCode: '', // 客户编码
        proDealSize: '', // 预计交易规模
        registeredCapital: '', // 注册资本
        realRegisteredCapitalCurrency: '', // 实收注册资本币种
        legalPersonType: '', // 法人类型
        establishTime: '', // 成立日期
        scale: '', // 人员规模
        personNum: '', // 参保人数
        establishUpdateTime: '', // 更新时间
        address: '', // 注册地址
        businessRange: '', // 经营范围
        revokeTime: '', // 吊销日期
        logoffTime: '', // 注销日期
        revokeReason: '', // 请输入吊销原因
        logoffReason: '', // 请输入注销原因
        applicantLimit: '', // 申请额度
        customFlag: '', // 是否涉及定制化
        applicantCategory: null, // 申请类别
        applicantPeriod: '', // 申请账期
        payType: [], // 付款方式
        otherPayType: '', // 付款方式-其他
        addMeasure: '', // 增信措施
        applicantReason: '', // 申请理由
        informFlag: false, // 审批结果是否通知，0否，1是
        email: '' // 邮箱
      },
      loading: false,
      isSendEmail: [
        { value: 1, label: '是' },
        { value: 0, label: '否' }
      ]
    };
  },
  model: {
    prop: 'form',
    event: 'change'
  },
  props: {

  },
  components: {
  },
  computed: {

  },
  methods: {
    setData (params, paramsExt) {
      Object.assign(this.formData, params);
      Object.assign(this.formDataExt, paramsExt);
    }
  },
  mounted () {
  }
};
</script>
<style lang="scss">
  .baseInfoForm {
    .el-form-item--mini.el-form-item {
      margin-bottom: 0;
    }
  }
</style>
<style lang="scss">
  .baseInfoForm{
    .el-form-item__error{
      position: relative;
    }
  }
  .required{
    color: red;
    margin-left: 3px;
  }
</style>
